module.exports = __webpack_public_path__ + "img/mnclogo.a718010f.png";